var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1665 21.6094L31.9087 7.125C31.6431 6.32812 31.0064 5.79297 30.1548 5.79297C29.3033 5.79297 28.6119 6.27344 28.3462 7.07031L25.5259 15.4844H15.6861L12.8658 7.07422C12.6001 6.27734 11.9087 5.79687 11.0572 5.79687C10.2056 5.79687 9.5142 6.32812 9.30327 7.12891L5.04936 21.6094C4.8892 22.1406 5.10405 22.7266 5.52983 23.0469L20.5845 34.3359L35.69 23.0469C36.1119 22.7305 36.3267 22.1445 36.1665 21.6094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.99f127ddfed8eb213001aa2bd39c3f8a.svg";
export { ForwardRef as ReactComponent };